export default "__VITE_ASSET__6fb3c2f6__"